/*
 * @Author: lumiaomei@leedarson.com
 * @Date: 2023-04-06 20:03:58
 * Copyright © Leedarson. All rights reserved.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@root/components/Input';
import Button from '@root/components/Button';
import Icon from '@root/components/Icon';
import useSecondCertification from '@root/hooks/login/useSecondCertification';
import './style.less';
import Timer from '@root/components/Timer';

const SecondCertification = () => {
  const { t } = useTranslation();
  const {
    code,
    resend,
    defaultCountDown,
    submitting,
    onSubmit,
    onIntervalEnd,
    onKeyDownCode,
    handleCodeChange,
    handleResendCode,
  } = useSecondCertification();

  const disabled = !code;

  return (
    <div className="login-container second-certification">
      <p className="second-certification-tip">{t('Authentication_Content')}</p>
      <div className="login-container-form">
        <div className="form-cell">
          <Icon type="ldsSecurity" />
          <Input
            className="form-cell-input"
            type="number"
            value={code || ''}
            onChange={handleCodeChange}
            onKeyDown={onKeyDownCode}
            placeholder={t('Verify_Code_Placeholder')}
            clear
          />
        </div>

        <div className="code-left-wrap">
          {resend ? (
            <span className="text-btn" onClick={handleResendCode}>
              {t('Resent_Code')}
            </span>
          ) : (
            <Timer
              type="countdown"
              format="mm:ss"
              countdown={defaultCountDown}
              render={(value: any) => (
                <p className="code-left">
                  {t('Verify_Code_Left', { time: value })}
                </p>
              )}
              onEnd={onIntervalEnd}
            />
          )}
        </div>
        <Button onClick={onSubmit} disabled={disabled} loading={submitting}>
          {t('Verify')}
        </Button>
      </div>
    </div>
  );
};

export default SecondCertification;
